import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import SmsPage from "../components/SmsPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const SmsPageContainer = connect(mapStateToProps, mapDispatchToProps)(SmsPage);

export default SmsPageContainer;


// WEBPACK FOOTER //
// ./src/containers/SmsPageContainer.js